"use strict";

var _regeneratorRuntime = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _asyncToGenerator = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authenticate = exports.authorizationHeaders = exports.encodeAuthentication = void 0;

var _base = _interopRequireDefault(require("base-64"));

var _utf = _interopRequireDefault(require("utf8"));

var _users = require("./users");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var encodeAuthentication = function encodeAuthentication(_ref) {
  var username = _ref.username,
      password = _ref.password,
      token = _ref.token;
  var authentication = '';

  if (token) {
    var sha1 = typeof token === 'object' ? token.sha1 : token;
    authentication = "token ".concat(sha1);
  } else if (username && password) {
    var encoded = _base.default.encode(_utf.default.encode("".concat(username, ":").concat(password)));

    authentication = 'Basic ' + encoded;
  }

  return authentication;
};

exports.encodeAuthentication = encodeAuthentication;

var authorizationHeaders = function authorizationHeaders(_ref2) {
  var username = _ref2.username,
      password = _ref2.password,
      token = _ref2.token;
  var headers = {
    'Content-Type': '',
    'Authorization': ''
  };
  var authorization = encodeAuthentication({
    username: username,
    password: password,
    token: token
  });

  if (authorization) {
    headers = {
      'Content-Type': 'application/json',
      'Authorization': authorization
    };
  }

  return headers;
};

exports.authorizationHeaders = authorizationHeaders;

var authenticate = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref3) {
    var username, password, config, token, user, _config, authHeaders, authentication;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            username = _ref3.username, password = _ref3.password, config = _ref3.config;
            _config = _objectSpread({}, config, {
              headers: {}
            });

            if (!(username && password)) {
              _context.next = 13;
              break;
            }

            authHeaders = authorizationHeaders({
              username: username,
              password: password
            });
            _config = _objectSpread({}, config, {
              headers: _objectSpread({}, config.headers, {}, authHeaders)
            });
            _context.next = 7;
            return (0, _users.getUser)({
              username: username,
              config: _config
            });

          case 7:
            user = _context.sent;
            _context.next = 10;
            return (0, _users.ensureToken)({
              username: username,
              config: _config
            });

          case 10:
            token = _context.sent;
            authHeaders = authorizationHeaders({
              token: token
            });
            _config = _objectSpread({}, config, {
              headers: _objectSpread({}, config.headers, {}, authHeaders)
            });

          case 13:
            authentication = {
              user: user,
              token: token,
              config: _config
            };
            return _context.abrupt("return", authentication);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function authenticate(_x) {
    return _ref4.apply(this, arguments);
  };
}();

exports.authenticate = authenticate;